import React, { Component } from 'react';
import Image from 'react-image-file';
import FileDrop from 'react-file-drop';

import './UploadStep.css';

class UploadStep extends Component {
    constructor(props) {
        super(props);

        // Check if we already have data for this step
        let pictures = [];
        const currentData = props.collectedData.uploadStep;

        if (typeof currentData === 'undefined') {
            // We haven't collected any data
            pictures = [];
        } else {
            const emptyPictureObject = (Object.keys(currentData).length === 0 && currentData.constructor === Object);
            pictures = emptyPictureObject ? [] : currentData;
        }

        this.state = {
            pictures: pictures
        };

        //Bind methods
        this.processDataForNextStep = this.processDataForNextStep.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.handleFileSubmit = this.handleFileSubmit.bind(this);
        this.removeImage = this.removeImage.bind(this);
    }

    processDataForNextStep() {
        let data = {};

        if (this.state.pictures.length === 0) {
            // Pass the data to the parent component state
            data = {
                'uploadStep': this.state.pictures
            };
            this.props.nextStep(data);

        } else {
                // Convert pictures to base64
                const base64Pictures = [];

                for (let i = 0; i < this.state.pictures.length; i++) {
                    let tempFile = this.state.pictures[i];

                    if (tempFile instanceof File) {
                        let reader = new FileReader();
                        reader.readAsDataURL(tempFile);
                        reader.onload = () => {
                            base64Pictures.push(reader.result);
                        };

                        reader.onerror = (error) => {
                            console.log('Error: ', error);
                        };
                    } else {
                        // It's already been encoded
                        base64Pictures.push(tempFile);
                    }
                }

                // Pass the data to the parent component state
                data = {
                    'uploadStep': base64Pictures
                };

                this.props.nextStep(data);
        }
    }

    onDrop(fileList) {
        if (fileList.length === 0) {
            return;
        }

        const picture = fileList[0];

        this.setState({
            pictures: this.state.pictures.concat([picture])
        });
    }

    handleFileSubmit(event) {
        if (event.target.files.length === 0) {
            return;
        }

        // Get the uploaded image
        const picture = event.target.files[0];

        this.setState({
            pictures: this.state.pictures.concat([picture])
        });
    }

    removeImage(idx) {
        let newPictures = this.state.pictures;
        newPictures.splice(idx, 1);
        this.setState({
           pictures: newPictures
        });
    }

    renderImages() {
        return this.state.pictures.map((picture, idx)=> (
            <div className="image-thumb" key={idx}>
                <div onClick={() => this.removeImage(idx)} className="remove-image-icon">
                    <i className="ion ion-android-close" />
                </div>

                <Image classname="image-asset" file={picture} />
            </div>
        ));
    }

    render() {
        return (
            <div className="upload-step">
                <div className="component-content container">
                    <div className="header">
                        <h1>Add some of your artwork.</h1>
                        <p>Not having any pictures / assets right now is <kbd>OK</kbd>, we'll just use the data you provide to create an account.</p>
                    </div>

                    <div id="uploadedImagesList">
                        {this.renderImages()}
                    </div>

                    <div className="main-upload-div">
                        <div className="non-dragover-overlay">
                            <form onChange={this.handleFileSubmit}>
                                <label>
                                    <input type="file" accept="image/*" name="image" />
                                    <a className="upload-button">Upload a file <kbd>or</kbd> drag a file in</a>
                                </label>
                            </form>
                        </div>

                        <FileDrop frame={document} onDrop={this.onDrop} >
                            <div className="dragover-overlay">
                                <div className="dragover-overlay-message">
                                    <i className="ion ion-ios-cloud-download" />
                                    <kbd>Drop 'Em.</kbd>
                                </div>
                            </div>
                        </FileDrop>
                    </div>

                    <div className="bottom-row">
                        <button id="previousButton" onClick={this.props.previousStep} className="circle-step-button">
                            <i className="ion ion-android-arrow-back" />
                        </button>

                        <button id="nextButton" onClick={this.processDataForNextStep} className="circle-step-button">
                            <i className="ion ion-android-arrow-forward" />
                        </button>
                    </div>
                </div>
            </div>
        );
    }

}

export default UploadStep;


// WEBPACK FOOTER //
// ./src/components/App/components/Main/components/Onboard/StepComponents/UploadStep/UploadStep.js